import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { extendObservable, runInAction, intercept } from 'mobx'
import styled, { keyframes } from 'styled-components'
import { TweenMax, TimelineMax } from 'gsap'
import { PACircle } from '@/Components/PACircle'
import LockWhiteIcon from '@/assets/images/icon-lock-white.svg'
import ArrowPushIcon from '@/assets/images/host-command-icon-arrow-push.svg'
import DDStar from '@/Components/CommandHost/Common/DDStar'
import TeamItem from '@/Components/CommandHost/Common/TeamItem'
import { OptionInputsWrapper } from './style'
import DDAnnounceSponsor from '@/Components/CommandHost/Common/DDAnnounceSponsor'
import PlayIcon from '@/assets/images/PlayPause/hc-play.png'
import PauseIcon from '@/assets/images/PlayPause/hc-pause.png'
import _, { isNumber } from 'lodash'
import InfinityIcon from '@/assets/images/PlayPause/infinity.png'
import { responsiveDimension } from '../../utils'

const PlayColors = {
  liveplay: '#c61818',
  gamemaster: '#19d1bf',
  sponsor: '#495bdb',
  prize: '#9368aa',
}

@inject(
  'PrePlayStore',
  'CommandHostStore',
  'AutomationStore',
  'GameStore',
  'CommonStore'
)
@observer
export default class PlayItemLoad extends Component {
  constructor(props) {
    super(props)
    FONT_SIZE = this.props.CommandHostStore.fontSize + 'vh'
    extendObservable(this, {
      timeLeft: 0,
      timeLeftCheck: null,
      timeLeftPauseAnim: false,
      adLeft: 0,
      adLeftCheck: null,
      adLeftPauseAnim: false,
      error: null,
      multiplier: 1,
      optionCount: 1,
      //presetItems: null,
      preItem: null,
      pushed: false,
      values: {
        index: 0,
        type: '',
        playTitle: '',
        choices: [],
        stars: 0,
        length: 0,
      },
      isPrepickLoaded: false,
      preStarted: false,
      isStarted: false,
      isEnded: false,
      activePlay: {
        id: 0,
        type: '',
        multiplier: 1,
        length: 0,
        withStar: false,
        playTitle: '',
        choices: [],
      },
      result: {
        id: 0,
        type: '',
        correctAnswer: '',
        correctAnswers: [],
        resultTitle: '',
        selectedTeam: {},
        withStar: false,
      },
      sessionStarted: this.props.GameStore.isSessionStarted,
      sourcePlayData: _.cloneDeep(this.props.item),
    })
    this.state = {
      timerInSeconds: 0,
      isPlayPaused: false,
      pausedTime: null,
      allow_unlim: false,
      isInifiniteIcon: false,
      isOpinionQuestion: false,
      isPregamePlay: false,
    }

    this.MAIN_CHOICE = this.props.item.multiplierChoices.filter(
      o => o.id == this.props.item.id
    )[0]

    this.destroySessionMode = intercept(
      this.props.GameStore,
      'sessionMode',
      change => {
        this.sessionStarted = change.newValue === 1
        return change
      }
    )
  }

  handleStartPlayClick() {
    this.props.startPlay()
    this.preStarted = true
    setTimeout(() => {
      this.isStarted = true
    }, 1500)
  }

  resolveOpinions() {
    const resultOptionLoadId = `currentplay-result-option-${this.props.item.type}-1-${this.props.item.id}`
    const automationMultiplierFlag = `currentplay-result-option-${this.props.item.type}-1`

    if (this.MAIN_CHOICE && this.MAIN_CHOICE.choices) {
      if (this.MAIN_CHOICE.readOnly && !this.MAIN_CHOICE.choices.length) {
        this.MAIN_CHOICE.choices.push({ value: '{player1}' })
        this.MAIN_CHOICE.choices.push({ value: '{player2}' })
      }
      const choices = this.MAIN_CHOICE.choices.sort(
        (a, b) => a.sequence - b.sequence
      )
      for (let i = 0; i < (choices || []).length; i++) {
        const mulChoice = choices[i]
        let propsItemChoice = this.props.item.choices.filter(o => {
          const _ov = (o.value || '').toLowerCase()
          if (_ov === (mulChoice.value || '').toLowerCase()) return true
          if (!mulChoice) return false
          const _mulChoice = this.preprocessPresetChoice(
            mulChoice.value,
            null,
            null,
            null,
            null,
            null,
            true
          )
          return _ov === (_mulChoice ? _mulChoice.toLowerCase() : '')
        })[0]
        if (
          propsItemChoice &&
          propsItemChoice.value &&
          choices[i].value &&
          propsItemChoice.value.toLowerCase() !==
            choices[i].value.toLowerCase() &&
          this.preprocessPresetChoice(choices[i].value, null, null, true)
        )
          propsItemChoice = choices[i]
        if (propsItemChoice) {
          this.handleSelectAnswer(
            this.MAIN_CHOICE,
            i,
            resultOptionLoadId,
            2,
            null,
            automationMultiplierFlag,
            true
          )
        }
      }
    }
  }

  async handleEndPlayClick(refId) {
    this.props.GameStore.setGAEnabled()
    let { PrePlayStore } = this.props
    if (
      this.props.item &&
      this.props.item.pmetadata &&
      this.props.item.pmetadata.public &&
      this.props.item.pmetadata.public.opinionQuestion
    ) {
      await this.resolveOpinions()
    } else if (
      this.props.item &&
      this.props.item.multiplierItems &&
      (this.result.correctAnswers.length === 0 ||
        this.props.item.multiplierItems.length + 1 !==
          this.result.correctAnswers.length)
    ) {
      this.props.endCurrentPlay(this.props.PrePlayStore.nextPlayItem)
      return
    }

    const _editorEvents = []
    if ('recording' === this.props.GameStore.executionType) {
      await _editorEvents.push({
        gameId: this.props.GameStore.gameId,
        playId: null,
        evt: 'delay',
        refId: refId,
        wait: 0,
        sequence: 0,
        isIncrementHeaderPlaySequence: false,
        isIncrementPlaySequence: false,
        isIncrementSequence: true,
        timestampWait: 0,
        isPreviousPlayEnded: true,
        isUseGlobalTimestampWait: true,
      })

      for (
        let i = 0;
        i < this.props.AutomationStore.tempUnresolvedEvents.length;
        i++
      ) {
        const event = this.props.AutomationStore.tempUnresolvedEvents[i]
        event.sequence = ++this.props.AutomationStore.sequence
        await _editorEvents.push(event)
      }

      await _editorEvents.push({
        gameId: this.props.GameStore.gameId,
        playId: this.props.item.id,
        evt: 'click',
        refId: refId,
        wait: 0,
        sequence: 0,
        isIncrementHeaderPlaySequence: false,
        isIncrementPlaySequence: false,
        isIncrementSequence: true,
        timestampWait: 0,
        isPreviousPlayEnded: false,
      })

      if (PrePlayStore.nextPlayItem && PrePlayStore.nextPlayItem.id) {
        await _editorEvents.push({
          gameId: this.props.GameStore.gameId,
          playId: PrePlayStore.nextPlayItem.id,
          evt: 'click',
          refId: `go-button-${PrePlayStore.nextPlayItem.type}-${PrePlayStore.nextPlayItem.id}`,
          wait: 0,
          sequence: 0,
          isIncrementHeaderPlaySequence: false,
          isIncrementPlaySequence: false,
          isIncrementSequence: true,
          timestampWait: 0,
          isPreviousPlayEnded: true,
        })
      }

      this.props.AutomationStore.resetCurrentTime()
    }

    this.isEnded = true
    setTimeout(() => {
      this.showResults(_editorEvents)
    }, 0)
  }

  showResults(_editorEvents) {
    this.result.correctAnswers.forEach(correctAnswer => {
      const option = document.getElementById(correctAnswer.highlightedOption)
      TweenMax.set(option, { backgroundColor: '#18c5ff' })
    })

    let multiItem = this.props.item.multiplierItems[
      this.props.item.multiplierItems.length - 1
    ]
    if (multiItem) {
      let multiChoice = this.props.item.multiplierChoices.filter(
        o => o.id === multiItem.id
      )[0]
      if (multiChoice) {
        multiChoice.locked = true
      }
    }

    if (this.ResultTitleInput)
      TweenMax.set(this.ResultTitleInput, {
        backgroundColor: '#18c5ff',
        color: '#ffffff',
        readOnly: true,
      })
    if (this[`playitemload-${this.props.item.index}`])
      TweenMax.set(this[`playitemload-${this.props.item.index}`], {
        backgroundColor: '#18c5ff',
        color: '#ffffff',
      })
    this.pushed = true

    this.result.hasNextPlay = this.props.PrePlayStore.nextPlayItem
      ? true
      : false
    this.props.item.result = this.result
    this.props.showResult({
      id: this.props.item.id,
      result: this.result,
      executionType: this.props.GameStore.executionType,
      editorEvents:
        'recording' === this.props.GameStore.executionType
          ? _editorEvents
          : null,
    })
    this.props.AutomationStore.resetTempUnresolvedEvents()
    // setTimeout(() => {
    //   this.props.resolve()
    // }, 3000)
  }

  handleShowResultClick() {
    this.error = null
    let required = []
    if (!this.result.correctAnswer) {
      required.push('Correct answer')
    }
    if (!this.result.resultTitle) {
      required.push('Results field')
    }
    if (!this.result.selectedTeam) {
      required.push('Team')
    }
    if (
      this.result.selectedTeam &&
      !this.result.selectedTeam.id &&
      !this.result.selectedTeam.teamName
    ) {
      required.push('Team')
    }

    if (required.length > 0) {
      this.error = required
      const promptRequired = document.getElementById('prompt-required')
      if (promptRequired) {
        setTimeout(() => {
          new TimelineMax({ repeat: 0 })
            .to(promptRequired, 0.1, { visibility: 'visible', opacity: 1 })
            .to(promptRequired, 0.1, {
              visibility: 'hidden',
              opacity: 0,
              delay: 3,
            })
        }, 0)
      }
    } else {
      this.result.correctAnswers.forEach(correctAnswer => {
        const option = document.getElementById(correctAnswer.highlightedOption)
        TweenMax.set(option, { backgroundColor: '#18c5ff' })
      })

      let multiItem = this.props.item.multiplierItems[
        this.props.item.multiplierItems.length - 1
      ]
      if (multiItem) {
        let multiChoice = this.props.item.multiplierChoices.filter(
          o => o.id === multiItem.id
        )[0]
        if (multiChoice) {
          multiChoice.locked = true
        }
      }

      TweenMax.set(this.ResultTitleInput, {
        backgroundColor: '#18c5ff',
        color: '#ffffff',
        readOnly: true,
      })
      TweenMax.set(this[`playitemload-${this.props.item.index}`], {
        backgroundColor: '#18c5ff',
        color: '#ffffff',
      })
      this.pushed = true

      this.props.item.result = this.result
      this.props.showResult(this.result)
      setTimeout(() => {
        this.props.resolve()
      }, 4000)
    }
  }

  handleSelectAnswer(
    multiplierChoice,
    index,
    reference,
    multiplierCountX,
    prevItemToLock,
    automationMultiplierFlag,
    isAutoResolvingOpinions
  ) {
    setTimeout(() => {
      if (multiplierCountX === 2) {
        this.props.item.multiplierItems = []
      }

      if (multiplierCountX === 3) {
        if (this.props.item.multiplierItems.length > 1) {
          for (let i = this.props.item.multiplierItems.length - 1; i > 0; i--) {
            this.props.item.multiplierItems.splice(i, 1)
          }
        }
      }
      // const down = this.props.item.multiplierItems.length - multiplierCountX
      // for (let x=this.props.item.multiplierItems.length - 1; x>=down; x--) {
      //   this.props.item.multiplierItems.splice(x, 1)
      // }

      for (let i = 0; i < (multiplierChoice.choices || []).length; i++) {
        const option = document.getElementById(`${reference}-${i}`)

        if (index === i) {
          const ans = multiplierChoice.choices[i]
          if (
            !isAutoResolvingOpinions &&
            (this.result.correctAnswer === ans.value ||
              this.result.resultTitle.includes(ans.value))
          ) {
            this.result.correctAnswer = ''
            let removedAnsIdx = null
            this.result.correctAnswers = this.result.correctAnswers.filter(
              (answer, idx) => {
                let isAnswerStays = true
                if (answer && answer.correctAnswer) {
                  isAnswerStays = answer.correctAnswer.value !== ans.value
                  if (!isAnswerStays) removedAnsIdx = idx
                }
                return (
                  isAnswerStays &&
                  (!isNumber(removedAnsIdx) || removedAnsIdx > idx)
                )
              }
            )
            try {
              let preResult = ''
              for (let x = 0; x < this.result.correctAnswers.length; x++) {
                const ca = this.result.correctAnswers[x]
                preResult += ca.correctAnswer.value + ', '
              }

              this.result.resultTitle = preResult.slice(0, -2)
            } catch (error) {
              console.error(' error while updating resultTitle : ', error)
            }
            if (option) {
              TweenMax.set(option, { backgroundColor: '#808285' })
            }
          } else {
            this.result.correctAnswer = ans.value

            this.pushCorrectAnswer(
              multiplierChoice.id,
              multiplierChoice.choices[i],
              multiplierCountX,
              `${reference}-${i}`
            )
            this.pushMultiplierItem(ans.nextId, ans.value, multiplierCountX)

            /**
             * Lock previous multiplier choice after selecting on the current choice
             */
            if (prevItemToLock) {
              prevItemToLock.locked = true
            }

            if (option) {
              TweenMax.set(option, { backgroundColor: '#0fbc1c' })
            }

            //this.props.AutomationStore.addEvent({evt:'click', refId: `${reference}-${i}`, wait: 0.5, playId: this.props.item.id})
            this.props.AutomationStore.addTempUnresolvedEvent({
              evt: 'click',
              refId: `${reference}-${i}`,
              wait: 0.5,
              playId: this.props.item.id,
              multiplierFlag: automationMultiplierFlag,
            })
          }
        } else {
          if (option) {
            TweenMax.set(option, { backgroundColor: '#808285' })
          }
        }
      }
    }, 0)
  }

  removeAnswer = (key, value) => {
    if (this.result) {
      if (key === 'id') {
        this.result.correctAnswers = this.result.correctAnswers.filter(
          answer => answer && answer.correctAnswer.id !== value
        )
        return
      }
      const toRemove = this.result.correctAnswers.filter(
        o => o[key] === value
      )[0]
      if (toRemove) {
        const idxToRemove = this.result.correctAnswers.indexOf(toRemove)
        if (idxToRemove > -1) {
          this.result.correctAnswers.splice(idxToRemove, 1)
        }
      }
    }
  }

  pushCorrectAnswer(id, correctAnswer, multiplierCountX, option) {
    /**
     * Remove existing answer
     */
    const answerMultipliers = [...this.result.correctAnswers]
    for (let i = answerMultipliers.length - 1; i >= 0; i--) {
      if (
        this.props.item &&
        this.props.item.pmetadata &&
        this.props.item.pmetadata.public &&
        this.props.item.pmetadata.public.opinionQuestion
      ) {
        if (
          correctAnswer &&
          answerMultipliers[i] &&
          answerMultipliers[i].correctAnswer &&
          answerMultipliers[i].correctAnswer.id === correctAnswer.id &&
          answerMultipliers[i].correctAnswer.value === correctAnswer.value
        ) {
          this.removeAnswer('id', correctAnswer.id)
        }
      } else {
        const mulX = answerMultipliers[i].multiplier
        if (mulX >= multiplierCountX) {
          this.removeAnswer('multiplier', mulX)
        }
      }
    }
    // const toRemove = this.result.correctAnswers.filter(
    //   o => o.multiplier === multiplierCountX
    // )[0]
    // if (toRemove) {
    //   const idxToRemove = this.result.correctAnswers.indexOf(toRemove)
    //   if (idxToRemove > -1) {
    //     this.result.correctAnswers.splice(idxToRemove, 1)
    //   }
    // }

    /**
     * Push new answer
     */
    let ans = {
      id: id,
      multiplier: multiplierCountX,
      correctAnswer: correctAnswer,
      highlightedOption: option,
    }
    this.result.correctAnswers.push(ans)

    let preResult = ''
    for (let x = 0; x < this.result.correctAnswers.length; x++) {
      const ca = this.result.correctAnswers[x]
      preResult += ca.correctAnswer.value + ', '
    }

    this.result.resultTitle = preResult.slice(0, -2)
  }

  pushMultiplierItem(nextId, answer, multiplierCountX) {
    /**
     * Remove existing item
     */
    /*
    const mulItems = [...this.props.item.multiplierItems]
    for (let i=mulItems.length - 1; i>=0; i--) {
      debugger
      const mulX = mulItems[i].multiplier
      if (mulX >= multiplierCountX) {
        const toRemove = this.props.item.multiplierItems.filter(o => o.multiplier === mulX)[0]
        if (toRemove) {
          const idxToRemove = this.props.item.multiplierItems.indexOf(toRemove)
          if (idxToRemove > -1) {
            this.props.item.multiplierItems.splice(idxToRemove, 1)
          }
        }
      }
    }
*/

    const multiItemToRemove = this.props.item.multiplierItems.filter(
      o => o.multiplier === multiplierCountX
    )[0]
    if (multiItemToRemove) {
      const multiItemIndex = this.props.item.multiplierItems.indexOf(
        multiItemToRemove
      )
      if (multiItemIndex > -1) {
        this.props.item.multiplierItems.splice(multiItemIndex, 1)
      }
    }

    /**
     * Push new item
     */
    let multiItem = this.props.item.multiplierChoices.filter(
      o => o.id === nextId
    )[0]
    if (multiItem) {
      multiItem.multiplier = multiplierCountX
      multiItem.previousAnswer = answer
      this.props.item.multiplierItems.push(multiItem)
    }

    this.forceUpdate()
  }

  handleResultTitleChange(e) {
    this.result.resultTitle = e.target.value
  }

  ResultOptions() {
    let comp = []
    let { item } = this.props

    if (!item) return null
    let hasTimer = item.length > 0
    const resultOptionLoadId = `currentplay-result-option-${this.props.item.type}-1-${this.props.item.id}`
    const automationMultiplierFlag = `currentplay-result-option-${this.props.item.type}-1`

    if (this.MAIN_CHOICE && this.MAIN_CHOICE.choices) {
      if (this.MAIN_CHOICE.readOnly && !this.MAIN_CHOICE.choices.length) {
        this.MAIN_CHOICE.choices.push({ value: '{player1}' })
        this.MAIN_CHOICE.choices.push({ value: '{player2}' })
      }
      const choices = this.MAIN_CHOICE.choices.sort(
        (a, b) => a.sequence - b.sequence
      )
      for (let i = 0; i < choices.length; i++) {
        const mulChoice = choices[i]
        let propsItemChoice = this.props.item.choices.filter(o => {
          const _ov = (o.value || '').toLowerCase()
          if (_ov === (mulChoice.value || '').toLowerCase()) return true
          if (!mulChoice) return false
          const _mulChoice = this.preprocessPresetChoice(
            mulChoice.value,
            null,
            null,
            null,
            null,
            null,
            true
          )
          return _ov === (_mulChoice ? _mulChoice.toLowerCase() : '')
        })[0]
        if (
          propsItemChoice &&
          propsItemChoice.value &&
          choices[i].value &&
          propsItemChoice.value.toLowerCase() !==
            choices[i].value.toLowerCase() &&
          this.preprocessPresetChoice(choices[i].value, null, null, true)
        )
          propsItemChoice = choices[i]
        if (propsItemChoice) {
          let _comp_from_tpl = propsItemChoice.value
            ? this.preprocessPresetChoice(
                propsItemChoice.value,
                resultOptionLoadId,
                i,
                item,
                hasTimer,
                automationMultiplierFlag
              )
            : null
          if (_comp_from_tpl) {
            comp.push(_comp_from_tpl)
          } else {
            comp.push(
              <ResultOption
                locked={!this.sessionStarted || hasTimer}
                id={`${resultOptionLoadId}-${i}`}
                key={`result-option-load${i}`}
                color={'#ffffff'}
                backgroundColor={
                  hasTimer ? PlayColors[item.type.toLowerCase()] : '#808285'
                }
                marginRight={
                  this.MAIN_CHOICE &&
                  i < (this.MAIN_CHOICE.choices || []).length - 1
                }
                onClick={
                  !this.sessionStarted
                    ? null
                    : hasTimer
                    ? null
                    : this.handleSelectAnswer.bind(
                        this,
                        this.MAIN_CHOICE,
                        i,
                        resultOptionLoadId,
                        2,
                        null,
                        automationMultiplierFlag
                      )
                }
              >
                {propsItemChoice.value}
              </ResultOption>
            )
          }
        }
      }
    }

    return comp
  }

  preprocessPresetChoice(
    choice,
    reference,
    i,
    item,
    hasTimer,
    automationMultiplierFlag,
    return_match
  ) {
    const field = choice.match(/^\{(\w+)\}$/)
    if (field) {
      const field_match = field[1].match(/^player(\d+)$/i)
      if (field_match) {
        if (return_match)
          return this.props.PrePlayStore.teams.length >= field_match[1]
            ? this.props.PrePlayStore.teams[field_match[1] - 1].teamName
            : null
        return this.preprocessPresetChoicePlayer(
          field_match[1],
          reference,
          i,
          item,
          hasTimer,
          automationMultiplierFlag
        )
      }
    }
    for (let _i = 0; _i < this.props.PrePlayStore.teams.length; ++_i) {
      if (this.props.PrePlayStore.teams[_i].teamName === choice)
        return return_match
          ? choice
          : this.preprocessPresetChoicePlayer(
              _i + 1,
              reference,
              i,
              item,
              hasTimer,
              automationMultiplierFlag
            )
    }
    return null
  }

  preprocessPresetChoicePlayer(
    player_number,
    reference,
    i,
    item,
    hasTimer,
    automationMultiplierFlag
  ) {
    const t = this.props.PrePlayStore.teams[player_number - 1]
    runInAction(() => {
      if (this.props.item.choices[i]) {
        this.props.item.choices[i].id = t.id
        this.props.item.choices[i].value = t.teamName
      }
      if (item.multiplierChoices[0].choices[i]) {
        item.multiplierChoices[0].choices[i].id = t.id
        item.multiplierChoices[0].value = t.teamName
      }
    })

    return (
      <TeamItemWrapper
        locked={!this.sessionStarted || hasTimer}
        id={`${reference}-${i}`}
        key={`result-option-load${i}`}
        backgroundColor={
          hasTimer ? PlayColors[item.type.toLowerCase()] : '#808285'
        }
        marginRight={
          this.MAIN_CHOICE && i < (this.MAIN_CHOICE.choices || []).length - 1
        }
        onClick={
          !this.sessionStarted
            ? null
            : hasTimer
            ? null
            : this.handleSelectAnswer.bind(
                this,
                item.multiplierChoices[0],
                i,
                reference,
                2,
                null,
                automationMultiplierFlag
              )
        }
      >
        <TeamItem team={t} />
      </TeamItemWrapper>
    )
  }

  MultiplierResultOptions() {
    let comp = []
    let { item } = this.props
    let hasTimer = item.length > 0 ? true : false

    for (let i = 0; i < item.multiplierItems.length; i++) {
      const multiplierChoice = item.multiplierItems[i]
      const choices = item.multiplierItems[i].choices
      const previousAnswer = item.multiplierItems[i].previousAnswer
      const multiplier = item.multiplierItems[i].multiplier

      const prevItemToLock = item.multiplierChoices[i]

      comp.push(
        <MultiplierResultOptionWrapperOuterRow key={i}>
          <PreviousAnswer>{previousAnswer}</PreviousAnswer>
          <MultiplierLabel>{multiplier}x</MultiplierLabel>
          <MultiplierResultOptionWrapperInner>
            {(choices || []).length > 0 &&
              choices.map((choice, idx) => {
                const resultOptionLoadMultiplierId = `currentplay-result-option-${this.props.item.type}-${multiplier}-${this.props.item.id}`
                const automationMultiplierFlag = `currentplay-result-option-${this.props.item.type}-${multiplier}`
                return (
                  <ResultOption
                    locked={!this.sessionStarted}
                    id={`${resultOptionLoadMultiplierId}-${idx}`}
                    key={idx}
                    color={'#ffffff'}
                    backgroundColor={
                      hasTimer ? PlayColors[item.type.toLowerCase()] : '#808285'
                    }
                    marginRight={idx < choices.length - 1}
                    onClick={
                      !this.sessionStarted
                        ? null
                        : this.handleSelectAnswer.bind(
                            this,
                            multiplierChoice,
                            idx,
                            resultOptionLoadMultiplierId,
                            i + 3,
                            prevItemToLock,
                            automationMultiplierFlag
                          )
                    }
                  >
                    {choice.value}
                  </ResultOption>
                )
              })}
          </MultiplierResultOptionWrapperInner>
        </MultiplierResultOptionWrapperOuterRow>
      )
    }

    return comp
  }

  copyChoicesIntoMultiplierChoices() {
    const multiChoice = this.props.item.multiplierChoices[0]
    if (multiChoice) {
      if (!multiChoice.question || multiChoice.question.trim().length < 1) {
        multiChoice.question = this.props.item.playTitle
          ? typeof this.props.item.playTitle.value === 'object'
            ? this.props.item.playTitle.value.value
            : this.props.item.playTitle.value
          : ''
      }
      multiChoice.choices = this.props.item.choices
    }
  }

  componentWillUnmount() {
    this.destroySessionMode()
    clearInterval(this.interval)
    clearTimeout(this.failsafeTimeout)

    // PARK TIEMR ON UNMOUNT
    // If we are the only session left, pause the play so it doesn't run "blind"
    // and correctly records the time for state recovery on refresh.
    const currentPlay = this.props.PrePlayStore.currentPlayItem
    const isPlayStillActive =
      currentPlay &&
      currentPlay.id === this.props.item.id &&
      currentPlay.inProcess

    if (
      isPlayStillActive &&
      this.props.PrePlayStore.isMainOperator &&
      this.props.PrePlayStore.activeSessionsCount <= 1 &&
      !this.state.isPlayPaused
    ) {
      this.handlePause()
    }
  }

  componentWillMount() {
    //---this.copyChoicesIntoMultiplierChoices()

    this.props.killPlayRemoved(false)

    if (!this.props.item.sponsor) {
      this.props.item.sponsor = this.props.PrePlayStore.sponsors[0]
    }

    this.props.item.multiplierItems = []
    this.props.item.showNextPlayAd = this.props.item.length > 0 ? true : false
    this.values = this.props.item
    this.timeLeft = this.props.item.length
    this.adLeft = this.props.item.sponsor.length

    if (this.props.item.lockedOut) {
      this.preStarted = true
      this.isStarted = true
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.item !== this.props.item) {
      this.values = nextProps.item
      if (nextProps.item.multiplierChoices) {
        this.MAIN_CHOICE = nextProps.item.multiplierChoices.filter(
          o => o.id == nextProps.item.id
        )[0]
      }
      this.activePlay = nextProps.item
      this.result.id = nextProps.item.id
      this.result.type = nextProps.item.type
      this.result.withStar = nextProps.item.stars
      this.result.selectedTeam = nextProps.item.team

      if (
        nextProps.item &&
        nextProps.item.pmetadata &&
        nextProps.item.pmetadata.public
      ) {
        const publicData = nextProps.item.pmetadata.public
        this.setState({
          isOpinionQuestion: publicData.opinionQuestion,
        })
      }
    }
  }

  componentDidMount() {
    this.activePlay = this.props.item

    this.result.id = this.props.item.id
    this.result.type = this.props.item.type
    this.result.withStar = this.props.item.stars
    this.result.selectedTeam = this.props.item.team
    if (this.MAIN_CHOICE && this.MAIN_CHOICE.choices) {
      this.MAIN_CHOICE.choices.forEach((choice, idx) => {
        if (choice) choice.id = choice.id || idx
      })
    }
    this.initTimer()
    setTimeout(() => {
      //this.props.loadPlay(this.activePlay)
      this.timeLeftCountdown()
    }, 0)
    delete this.props.item.editorEvents
    const questionInputCont = document.getElementById(
      'play_item_load_question_input_locked'
    )
    if (questionInputCont) {
      this.scrollHeight = questionInputCont.scrollHeight || 0
      this.clientHeight = questionInputCont.clientHeight || 0
    }
    if (
      this.props.item &&
      this.props.item.pmetadata &&
      this.props.item.pmetadata.public
    ) {
      const publicData = this.props.item.pmetadata.public
      this.setState({
        isOpinionQuestion: publicData.opinionQuestion,
      })
    }
    this.forceUpdate()
  }

  componentDidUpdate(prevProps, prevState) {
    const isPmetaDiff = this.props.item.pmetadata !== prevProps.item.pmetadata
    const isSessionStartedDiff =
      this.props.GameStore.isSessionStarted !==
      prevProps.GameStore.isSessionStarted
    const isMainOperatorDiff =
      this.props.PrePlayStore.mainOperatorId !==
      prevProps.PrePlayStore.mainOperatorId

    if (isPmetaDiff || isSessionStartedDiff || isMainOperatorDiff) {
      this.initTimer()
    }
  }

  updateTimer() {
    if (
      this.state.isPlayPaused ||
      this.state.isInifiniteIcon ||
      this.state.timerInSeconds === 0
    ) {
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
      return
    }

    if (this.interval) {
      // Already running
      return
    }
    this.interval = setInterval(() => {
      if (
        this.sessionStarted &&
        !this.state.isPlayPaused &&
        !this.state.isInifiniteIcon
      ) {
        const play = this.props.item
        let parsedMetadata = play.pmetadata
        if (typeof parsedMetadata === 'string' && parsedMetadata) {
          try {
            parsedMetadata = JSON.parse(parsedMetadata)
          } catch (e) {
            parsedMetadata = {}
          }
        }
        parsedMetadata = parsedMetadata || {}

        const duration = this.getBaselineDurationSeconds()
        if (
          duration !== 'unlimited' &&
          !isNaN(duration) &&
          parsedMetadata.playStartTime
        ) {
          const serverTime = this.props.PrePlayStore.getServerTime()
          const elapsedMs = Math.max(
            0,
            serverTime - new Date(parsedMetadata.playStartTime)
          )
          const remainingFloat = Math.max(0, duration - elapsedMs / 1000)
          const displaySeconds = Math.ceil(remainingFloat)

          if (displaySeconds !== this.state.timerInSeconds) {
            this.setState({ timerInSeconds: displaySeconds }, () => {
              if (displaySeconds === 0) {
                clearInterval(this.interval)
                this.interval = null
                clearTimeout(this.failsafeTimeout)
                this.failsafeTimeout = null
                if (!this.props.PrePlayStore.nextPlayItem) {
                  this.setState({ isInifiniteIcon: true })
                }
              }
            })
          }
        }
      }
    }, 100)
  }

  initTimer() {
    clearTimeout(this.failsafeTimeout)
    this.failsafeTimeout = null
    const play = this.props.item
    let { time_limit } = this.props.GameStore.sportType || {}
    const playType =
      (play.type || '').toLowerCase() === 'live'
        ? 'LivePlay'
        : (play.type || '').toLowerCase()
    const isPregamePlay =
      this.props.item.multiplierChoices && this.props.item.multiplierChoices[0]
        ? (this.props.item.multiplierChoices[0].preset || '')
            .toLowerCase()
            .includes('pg')
        : false
    this.setState({ isPregamePlay })
    time_limit =
      time_limit && time_limit[playType]
        ? time_limit[playType][isPregamePlay ? 'pregame' : 'live_simulcast'] ||
          null
        : null

    if (time_limit && +time_limit.allow_unlim === 1) {
      this.setState({ allow_unlim: true })
    }
    const {
      item: { pmetadata = {} },
    } = this.props

    let parsedMetadata = pmetadata
    if (typeof pmetadata === 'string' && pmetadata) {
      try {
        parsedMetadata = JSON.parse(pmetadata)
      } catch (e) {
        parsedMetadata = {}
      }
    }

    let duration =
      parsedMetadata && parsedMetadata.pausedTime
        ? parsedMetadata.pausedTime
        : this.getBaselineDurationSeconds()

    duration = !isNaN(duration) && duration !== null ? +duration : duration

    let isPlayPaused =
      parsedMetadata && _.isBoolean(parsedMetadata.isPlayPaused)
        ? parsedMetadata.isPlayPaused
        : this.state.isPlayPaused
    let serverTime = this.props.PrePlayStore.getServerTime()
    let timerInSeconds = 0
    if (duration !== 'unlimited' && !isNaN(duration)) {
      if (isPlayPaused) {
        timerInSeconds = duration
      } else if (parsedMetadata && parsedMetadata.playStartTime) {
        const elapsedMs = Math.max(
          0,
          serverTime - new Date(parsedMetadata.playStartTime)
        )
        const remainingFloat = Math.max(0, duration - elapsedMs / 1000)
        timerInSeconds = Math.ceil(remainingFloat)
      } else {
        timerInSeconds =
          this.state &&
          this.state.timerInSeconds !== undefined &&
          this.state.timerInSeconds !== null &&
          this.state.timerInSeconds > 0
            ? this.state.timerInSeconds
            : duration
      }
      timerInSeconds = timerInSeconds < 0 ? 0 : timerInSeconds
    } else {
      timerInSeconds = duration
    }

    this.setState(
      {
        timerInSeconds: timerInSeconds,
        isPlayPaused: isPlayPaused,
        isInifiniteIcon: !duration || duration === 'unlimited' ? true : false,
      },
      () => {
        if (isPlayPaused) {
          if (this.interval) {
            clearInterval(this.interval)
            this.interval = null
          }
        } else {
          this.updateTimer()
        }
      }
    )
  }

  getBaselineDurationSeconds() {
    const play = this.props.item
    let { time_limit } = this.props.GameStore.sportType || {}
    const playType =
      (play.type || '').toLowerCase() === 'live'
        ? 'LivePlay'
        : (play.type || '').toLowerCase()
    const isPregamePlay =
      this.props.item.multiplierChoices && this.props.item.multiplierChoices[0]
        ? (this.props.item.multiplierChoices[0].preset || '')
            .toLowerCase()
            .includes('pg')
        : false
    time_limit =
      time_limit && time_limit[playType]
        ? time_limit[playType][isPregamePlay ? 'pregame' : 'live_simulcast'] ||
          null
        : null

    const {
      item: { pmetadata = {} },
    } = this.props

    let duration =
      pmetadata && pmetadata.timerInput
        ? pmetadata.timerInput
        : time_limit
        ? time_limit.default
        : null

    if (
      duration !== 'unlimited' &&
      !isNaN(duration) &&
      time_limit &&
      time_limit.unit === 'min'
    ) {
      duration = duration * 60
    }

    return !isNaN(duration) && duration !== null ? +duration : duration
  }

  timeLeftCountdown() {
    this.timeLeftPauseAnim = true
    this.adLeftPauseAnim = true

    if (this.timeLeft) {
      if (!this['playitemload-timeleft-' + this.props.item.index]) {
        return
      }

      let startTimer = () => {
        this.timeLeftPauseAnim = false
        TweenMax.set(this['playitemload-timeleft-' + this.props.item.index], {
          opacity: 1,
        })
        this.timeLeftCheck = setInterval(() => {
          this.timeLeft = this.timeLeft - 1
          if (!this.timeLeft) {
            clearInterval(this.timeLeftCheck)
            TweenMax.set(
              this['playitemload-timeleft-' + this.props.item.index],
              { opacity: 0.1 }
            )
            this.timeLeftPauseAnim = true
            this.adLeftCountdown()
          }
        }, 1000)
      }

      setTimeout(() => {
        startTimer()
      }, 2000)
    }
  }

  adLeftCountdown() {
    if (this.adLeft) {
      if (!this['playitemload-adleft-' + this.props.item.index]) {
        return
      }

      let startTimer = () => {
        this.adLeftPauseAnim = false
        TweenMax.set(this['playitemload-adleft-' + this.props.item.index], {
          opacity: 1,
        })
        this.props.killPlayRemoved(true)
        this.adLeftCheck = setInterval(() => {
          this.adLeft = this.adLeft - 1
          if (!this.adLeft) {
            clearInterval(this.adLeftCheck)
            TweenMax.set(this['playitemload-adleft-' + this.props.item.index], {
              opacity: 0.1,
            })
            this.adLeftPauseAnim = true
            this.result.resultTitle = ''
            this.result.selectedTeam = this.props.PrePlayStore.teams[0]
            this.props.showResult(this.result)
            setTimeout(() => {
              this.props.resolve()
            }, 0)
          }
        }, 1000)
      }

      setTimeout(() => {
        startTimer()
      }, 2000)
    }
  }

  handleSelectedSponsor(val, isAutomatic) {
    if (!this.props.item.pmetadata) this.props.item.pmetadata = {}
    if (!this.props.item.pmetadata.public) this.props.item.pmetadata.public = {}

    if (isAutomatic === 'Undo') {
      this.props.item.pmetadata.public.isManualOverride = false
    } else {
      this.props.item.pmetadata.public.isManualOverride = true
    }

    this.props.item.sponsor = val
    this.props.item.sponsorExpanded = false
    if (!val) {
      this.sponsorEnable(0, false)
    }
    this.forceUpdate()
  }

  sponsorEnable(val, isExpanded) {
    if (val === 1) {
      const bottomEditorReadOnly = document.getElementsByClassName(
        `${this.reference}-bottom-readonly`
      )
      const bottomEditor = document.getElementsByClassName(
        `${this.reference}-bottom`
      )
      const bottomSponsor = document.getElementsByClassName(
        `${this.reference}-sponsor`
      )
      if (bottomEditorReadOnly && bottomEditor && bottomSponsor) {
        TweenMax.set(bottomEditorReadOnly, { display: 'none' })
        TweenMax.set(bottomEditor, { display: 'none' })
        TweenMax.set(bottomSponsor, { display: 'block' })
        this.props.item.sponsorExpanded = isExpanded
      }
    } else {
      const bottomEditorReadOnly = document.getElementsByClassName(
        `${this.reference}-bottom-readonly`
      )
      const bottomEditor = document.getElementsByClassName(
        `${this.reference}-bottom`
      )
      const bottomSponsor = document.getElementsByClassName(
        `${this.reference}-sponsor`
      )
      if (bottomEditorReadOnly && bottomEditor && bottomSponsor) {
        // TweenMax.set(bottomEditorReadOnly, { display: 'flex' })
        TweenMax.set(bottomEditor, { display: 'none' })
        // TweenMax.set(bottomSponsor, { display: 'none' })
      }
    }
  }

  getType(type) {
    type = type.toLowerCase()
    return type === 'liveplay'
      ? 'live'
      : type === 'gamemaster'
      ? 'game'
      : type === 'sponsor'
      ? 'spon'
      : type === 'prize'
      ? 'priz'
      : type
  }

  async handlePauseUpdatePlay(playState) {
    if (this.props.item) {
      const { isPlayPaused, pausedTime, timerInSeconds } = this.state
      let play = JSON.parse(JSON.stringify(this.props.item))
      if (typeof play.pmetadata === 'string' && play.pmetadata) {
        try {
          play.pmetadata = JSON.parse(play.pmetadata)
        } catch (e) {
          play.pmetadata = {}
        }
      }
      play.pmetadata = play.pmetadata || {}
      if (playState === 'paused') {
        // save paused time to server if play is paused
        if (isPlayPaused) {
          play.pmetadata.pausedTime = timerInSeconds
          play.pmetadata.isPlayPaused = isPlayPaused
          play.pmetadata.playStartTime = ''
          this.props.GameStore.updatePlay(play)
        }
      } else {
        const baselineDuration = this.getBaselineDurationSeconds()
        const elapsed =
          baselineDuration && !isNaN(baselineDuration)
            ? baselineDuration - timerInSeconds
            : 0

        play.pmetadata.isPlayPaused = isPlayPaused
        play.pmetadata.playStartTime = new Date(
          this.props.PrePlayStore.getServerTime().getTime() - elapsed * 1000
        )
        play.pmetadata.pausedTime = ''
        this.props.GameStore.updatePlay(play)
      }
    }
  }

  handlePause = async () => {
    await this.setState(
      prevState => ({
        isPlayPaused: true,
        pausedTime: prevState.timerInSeconds,
      }),
      () => {
        clearInterval(this.interval)
      }
    )
    this.handlePauseUpdatePlay('paused')
  }

  handlePlay = () => {
    this.setState({ isPlayPaused: false }, () => {
      if (this.state.pausedTime !== null) {
        const remainingTime = this.state.pausedTime
        this.setState(
          { timerInSeconds: remainingTime, pausedTime: null },
          this.updateTimer
        )
      } else {
        this.updateTimer()
      }
      this.handlePauseUpdatePlay('played')
    })
  }

  formatTimerInput(totalSeconds) {
    const minutes = Math.floor(totalSeconds / 60)
    const seconds = totalSeconds % 60

    // Using padStart to ensure 2 digits for seconds (e.g., 5:04)
    return `${minutes}:${seconds.toString().padStart(2, '0')}m`
  }

  render() {
    let { item } = this.props
    if (!item) return null
    let bg = PlayColors[this.props.item.type.toLowerCase()]
    // let isLocked =
    //   !this.isEnded ||
    //   this.pushed ||
    //   (!this.result.correctAnswer ||
    //     !this.result.selectedTeam ||
    //     !this.result.resultTitle)

    let isLocked =
      !this.isStarted ||
      !this.result.correctAnswer ||
      !this.result.selectedTeam ||
      !this.result.resultTitle

    // let isEndPlayButtonHidden =
    //   this.props.item.multiplierItems.length + 1 !==
    //   this.result.correctAnswers.length
    //     ? true
    //     : false
    const isEndPlayButtonHidden = !this.props.PrePlayStore.nextPlayItem
      ? true
      : false

    const endButtonId = `end-button-${item.type}-${item.id}`
    const {
      timerInSeconds,
      isPlayPaused,
      isInifiniteIcon,
      pausedTime,
      isOpinionQuestion,
    } = this.state
    this.mainOperatorId = this.props.PrePlayStore.mainOperatorId
    return (
      <Container>
        <RowWrapper>
          <Wrapper>
            <StackWrapper>
              <Main>
                <PlayStatusWrapper />
                <PlayTypeDD>
                  <PrePlaySequence
                    backgroundColor={bg}
                    text={`${item.sequence}`}
                  />
                  <PrePlayLocked backgroundColor={bg}>
                    <span>{`${this.getType(item.type)}`}</span>
                    {isOpinionQuestion && (
                      <TextButton
                        name="opn"
                        color={'#000'}
                        backgroundColor={'#EFDF18'}
                        width={1.7}
                        height={1.2}
                      >
                        {'OPN'}
                      </TextButton>
                    )}
                  </PrePlayLocked>
                </PlayTypeDD>
                <SelectTypeLocked
                  title={this.MAIN_CHOICE && this.MAIN_CHOICE.preset}
                >
                  {this.MAIN_CHOICE && this.MAIN_CHOICE.preset}
                </SelectTypeLocked>
                <QuestionInputLocked
                  id="play_item_load_question_input_locked"
                  style={{
                    alignItems:
                      this.scrollHeight - this.clientHeight > 5
                        ? 'flex-start'
                        : 'center',
                  }}
                >
                  {item.playTitle
                    ? typeof item.playTitle.value === 'object'
                      ? item.playTitle.value.value
                      : item.playTitle.value
                    : ''}
                </QuestionInputLocked>
                <OptionInputsWrapper style={{ width: '24.5%' }}>
                  {this.ResultOptions()}
                </OptionInputsWrapper>
                <StarWrapper>
                  <DDStar
                    locked
                    item={item}
                    height={h}
                    index={'playitemload-' + item.index}
                    //value={val => {this.props.item.stars = val}}
                  />
                </StarWrapper>
                <AwardsDisplay backgroundColor={bg}>
                  {this.props.CommonStore.displayAwards(item)}
                </AwardsDisplay>
                {/* <SponsorBrandWrapper>
                  <DDSponsorBrand
                    height={h}
                    index={'playitemload-' + item.index}
                    selectedSponsor={item.sponsor}
                    value={val => {
                      item.sponsor = val
                    }}
                    locked
                  />
                </SponsorBrandWrapper> */}
                {item.length > 0 ? (
                  <TimerGroup>
                    <TimeLeft
                      innerRef={ref =>
                        (this['playitemload-timeleft-' + item.index] = ref)
                      }
                    >
                      <TimeLeftLabel>TIME LEFT</TimeLeftLabel>
                      <TimeLeftTimer>
                        <PACircle
                          size={9}
                          value={true}
                          pauseAnim={this.timeLeftPauseAnim}
                        >
                          <Bold>{this.timeLeft}s</Bold>
                        </PACircle>
                      </TimeLeftTimer>
                    </TimeLeft>
                    <AdLeft
                      innerRef={ref =>
                        (this['playitemload-adleft-' + item.index] = ref)
                      }
                    >
                      <TimeLeftLabel>AD LEFT</TimeLeftLabel>
                      <TimeLeftTimer>
                        <PACircle
                          size={9}
                          value={true}
                          pauseAnim={this.adLeftPauseAnim}
                        >
                          <Bold>{this.adLeft}s</Bold>
                        </PACircle>
                      </TimeLeftTimer>
                    </AdLeft>
                  </TimerGroup>
                ) : (
                  <PIPAutoLockIn
                    color={PlayColors[this.props.item.type.toLowerCase()]}
                  >
                    <PIPAutoLockInTimer
                      backgroundColor={
                        PlayColors[this.props.item.type.toLowerCase()]
                      }
                      width={timerInSeconds > 60 ? '5.3' : '5'}
                      size={timerInSeconds > 60 ? '1.8' : '2.3'}
                    >
                      {isInifiniteIcon ? (
                        <InfinityIconCont src={InfinityIcon} />
                      ) : (
                        `${
                          timerInSeconds >= 0
                            ? timerInSeconds <= 60
                              ? timerInSeconds + 's'
                              : this.formatTimerInput(timerInSeconds)
                            : '0s'
                        }`
                      )}
                    </PIPAutoLockInTimer>
                  </PIPAutoLockIn>
                )}
                <TimerControl
                  locked={!this.sessionStarted || isEndPlayButtonHidden}
                >
                  {isInifiniteIcon || isPlayPaused ? (
                    <PlayIconCont
                      src={PlayIcon}
                      onClick={e => {
                        e.stopPropagation()
                        if (!isInifiniteIcon && this.sessionStarted)
                          this.handlePlay()
                      }}
                      allow_unlim={isInifiniteIcon}
                    />
                  ) : (
                    <PauseIconCont
                      src={PauseIcon}
                      onClick={e => {
                        e.stopPropagation()
                        if (!isInifiniteIcon) this.handlePause()
                      }}
                      allow_unlim={isInifiniteIcon}
                    />
                  )}
                  <span style={{ display: 'none' }}>
                    {this.props.PrePlayStore.mainOperatorId}
                  </span>
                </TimerControl>
              </Main>

              <Sub id={`sub-container-${item.index}`} />
              <MultiplierWrapper>
                {this.MultiplierResultOptions()}
              </MultiplierWrapper>
            </StackWrapper>

            {item.length > 0 ? null : (
              <ResultWrapper>
                <BlankCell />
                <ResultLabel>RESULTS</ResultLabel>
                <ResultTitleInput
                  innerRef={ref => (this.ResultTitleInput = ref)}
                  type="text"
                  placeholder="results field"
                  value={this.result.resultTitle}
                  onChange={this.handleResultTitleChange.bind(this)}
                />
                <DDSponsorWrapper
                  className={`${this.reference}-sponsor`}
                  style={{
                    display: 'block',
                    marginLeft: '0.2vh',
                  }}
                >
                  <DDAnnounceSponsor
                    locked
                    height={h}
                    index={`${this.reference}-sponsor`}
                    selectedSponsor={item.sponsor}
                    value={this.handleSelectedSponsor.bind(this)}
                    expanded={item.sponsorExpanded}
                    type={item ? item.type : ''}
                    subType={item ? item.subType : null}
                    sponsorId={item.sponsorId}
                    sponsorMetaData={
                      item.sponsor ? item.sponsor.sponsorItem || null : null
                    }
                    pmetadata={
                      item.pmetadata ? item.pmetadata.public || null : null
                    }
                  />
                </DDSponsorWrapper>
                {/* {this.props.PrePlayStore.teams ? (
                  <TeamWrapper>
                    <DDTeam
                      locked={this.pushed}
                      item={item}
                      height={h}
                      index={'playitemload-' + item.index}
                      teams={this.props.PrePlayStore.teams}
                      reference={ref =>
                        (this[`playitemload-${item.index}`] = ref)
                      }
                      value={val => {
                        this.result.selectedTeam = val
                      }}
                    />
                  </TeamWrapper>
                ) : (
                  <DDTeamLoading />
                )} */}
                {/*TO BE DELETED
            <ResultButton
              locked={isLocked}
              onClick={isLocked ? null : this.handleShowResultClick.bind(this)}
            >
              <Prompt id={'prompt-required'}>
                {this.error ? (
                  <div>
                    <div>Required:</div>
                    {this.error.map((err, idx) => {
                      return <div key={idx}>{err}</div>
                    })}
                  </div>
                ) : null}
              </Prompt>
            </ResultButton>
*/}
              </ResultWrapper>
            )}
          </Wrapper>

          <EndPlayButtonBig>
            <EndPlayButton
              id={endButtonId}
              locked={!this.sessionStarted || isEndPlayButtonHidden}
              onClick={
                !this.sessionStarted
                  ? null
                  : this.handleEndPlayClick.bind(this, endButtonId)
              }
            />
          </EndPlayButtonBig>
        </RowWrapper>
      </Container>
    )
  }
}

const h = 5
let FONT_SIZE = '1.8'

const AwardsDisplay = styled.div`
  background-color: ${props => props.backgroundColor};
  color: white;
  height: 100%;
  padding-left: 2px;
  padding-right: 2px;
  font-family: pamainregular;
  max-width: 8%;
`

const Container = styled.div`
  width: 100%;
  height: auto;
  opacity: 0;
  animation: ${props => fadeIn} 0.3s forwards;
  display: flex;
`
const fadeIn = keyframes`
  0%{opacity: 0;}
  100%{opacity: 1}
`

const RowWrapper = styled.div`
  width: inherit;
  height: inherit;
  display: flex;
  //justify-content: space-between;
`

const EndPlayButtonBig = styled.div`
  position: absolute;
  left: 92.8%;
  width: 7.2%;
  height: 100%;
  display: flex;
`

const EndPlayButton = styled.div`
  position: absolute;
  width: 100%;
  height: ${props => props.height || '100%'};
  background-color: #c61818;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${props => 2.4}vh;
  color: white;
  cursor: ${props => (props.locked ? 'default' : 'pointer')};
  &:after {
    content: 'END PLAY';
  }
  visibility: ${props => (props.locked ? 'hidden' : 'visible')};
`

const TimerControl = styled.div`
  display: flex;
  position: relative;
  width: 6%;
  height: inherit;
  background-color: transparent;
  justify-content: center;
  align-items: center;
  visibility: ${props => (props.locked ? 'hidden' : 'visible')};
`

const PlayIconCont = styled.img`
  width: 30%;
  cursor: ${props => (props.allow_unlim ? '' : 'pointer')};
`
const PauseIconCont = styled.img`
  width: 30%;
  cursor: ${props => (props.allow_unlim ? '' : 'pointer')};
`

const Wrapper = styled.div`
  width: inherit;
  height: inherit;
  margin-top: ${props => 0.1}vh;
  margin-bottom: ${props => 0.1}vh;
  padding: ${props => 1.5}vh 0 ${props => 1.5}vh 0;
  user-select: text;
`

const Main = styled.div`
  width: inherit;
  height: ${props => h}vh;
  display: flex;
  flex-direction: row;
  align-items: center;
`

const Sub = styled.div`
  width: 90%;
  background: yellow;
`

const PrePlaySequence = styled.div`
  width: 40%;
  height: ${props => h}vh;
  background-color: ${props => props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: pamainlight;
  font-size: ${props => FONT_SIZE};
  color: white;
  line-height: 1;
  border-right: 0.5px solid;
  &:after {
    content: '${props => props.text}';
  }
`

const PrePlayLocked = styled.div`
  width: 60%;
  height: ${props => h}vh;
  background-color: ${props => props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
  color: white;
  text-transform: uppercase;
`

const TextButton = styled.div`
  position: absolute;
  left: 9.9%;
  top: 25.4%;
  padding-top: 0.1%;
  width: ${props => responsiveDimension(props.width || 2)};
  height: ${props => responsiveDimension(props.height || 2)};
  color: ${props => props.color || '#fff'};
  background-color: ${props => props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: pamainregular;
  font-size: ${props => responsiveDimension(0.7)};
  border: ${responsiveDimension(0.2)} solid #000;
  opacity: ${props => (props.isDisabled ? 0 : '')};
  pointer-events: ${props => (props.isDisabled ? 'none' : '')};
`

const PlayTypeDD = styled.div`
  width: 8%;
  height: ${props => h}vh;
  display: flex;
`
const PlayStatusWrapper = styled.div`
  width: 3%;
  height: ${props => h}vh;
  background-color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-image: url(${LockWhiteIcon});
  background-repeat: no-repeat;
  background-size: 50%;
  background-position: center;
`

const QuestionInputLocked = styled.div`
  width: 20.6%;
  height: inherit;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
  text-transform: uppercase;
  background-color: #ffffff;
  display: flex;
  align-items: flex-start;
  padding-left: 1vh;
  overflow-y: scroll;
  ms-overflow-style: ${'-ms-autohiding-scrollbar'};
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0.3vh rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
    border-radius: ${props => 1}vh;
  }
  &::-webkit-scrollbar {
    width: ${props => responsiveDimension(0.4)};
    background-color: #f5f5f5;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 0, 0, 0.6);
    &:hover {
      background-color: rgba(255, 0, 0, 1);
    }
    border-radius: ${props => 1}vh;
  }
  line-height: 1.6;
`

const SelectTypeLocked = styled.div`
  width: 7%;
  height: ${props => h}vh;
  background-color: #e5e5e5;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
  color: #000000;
  text-transform: uppercase;
  display: block;
  text-align: center;
  line-height: ${props => h}vh;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 0.5vh;
`

const StarWrapper = styled.div`
  width: 3%;
  height: ${props => h}vh;
`
const SponsorBrandWrapper = styled.div`
  width: 13%;
  height: ${props => h}vh;
`

const TeamItemWrapper = styled.div`
  width: 100%;
  height: inherit;
  background-color: ${props => props.backgroundColor || '#808285'};
  cursor: ${props => (props.locked ? 'default' : 'pointer')};
  ${props => (props.marginRight ? `margin-right:${2}px` : ``)};
`

const StackWrapper = styled.div`
  width: inherit;
  height: inherit;
  display: flex;
  flex-direction: column;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
`

const MultiplierWrapper = styled.div`
  width: 100%;
  height: inherit;
  display: flex;
  flex-direction: column;
`

const ResultWrapper = styled.div`
  width: 100%;
  height: ${props => h}vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
  margin-top: ${props => 0.2}vh;
`

const BlankCell = styled.div`
  width: 54%;
  height: ${props => h}vh;
`

const ResultLabel = styled.div`
  width: 5%;
  height: ${props => h}vh;
  background-color: #18c5ff;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ResultOption = styled.div`
  width: 100%;
  height: ${props => h}vh;
  background-color: ${props => props.backgroundColor || '#808285'};
  text-align: center;
  text-transform: uppercase;
  color: ${props => props.color};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${props => (props.locked ? 'default' : 'pointer')};
  ${props => (props.marginRight ? `margin-right:${2}px` : ``)};
`

const MultiplierResultOptionWrapperOuterRow = styled.div`
  height: inherit;
  display: flex
  flex-direction: row;
  margin-top: ${props => 0.2}vh;
  margin-left: 25.1%;
`

const MultiplierResultOptionWrapperInner = styled.div`
  //width: ${props => 19.8}vw;
  width: 26.59%;
  height: inherit;
  display: flex;
  justify-content: space-between;
`

const PreviousAnswer = styled.div`
  width: ${props => 6.9}vw;
  height: inherit;
  background-color: #0fbc1c;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  color: #ffffff;
`

const MultiplierLabel = styled.div`
  width: ${props => 2}vw;
  height: inherit;
  background-color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  color: #ffffff;
`

const ResultTitleInput = styled.input`
  width: 23%;
  height: inherit;
  background-color: #ffffff;
  text-indent: ${props => 1}vh;
  border: none;
  outline: none;
  text-transform: uppercase;
  color: #000000;
  border-right: ${props => 0.1}vh solid #414042;
`

const DDTeamLoading = styled.div`
  width: ${props => 15}vh;
  height: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  color: #000000;
  &:after {
    content: 'LOADING...';
  }
`

const TeamWrapper = styled.div`
  width: 10.4%;
  height: inherit;
  //border-left: ${props => 0.2}vh solid black;
  position: relative;
`

const PIPAutoLockIn = styled.div`
  width: 14.5%;
  height: inherit;
  color: ${props => props.color || '#c61818'};
  background-color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  &:after {
    content: 'PIP - AUTO LOCK IN';
    display: flex;
    width: 75%;
    justify-content: flex-start;
  }
  opacity: ${props => (props.isStarted ? 0.2 : 1)};
`

const PIPAutoLockInTimer = styled.div`
  width: ${props => props.width || 5}vh;
  height: ${props => 5}vh;
  border-top-left-radius: ${props => 5}vh;
  border-bottom-left-radius: ${props => 5}vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0;
  font-family: pamainregular;
  font-size: ${props => props.size || 2.3}vh;
  color: #ffffff;
  background-color: ${props => props.backgroundColor || '#c61818'};
`

const ButtonGroup = styled.div`
  height: inherit;
  display: flex;
  flex-direction: row;
`

const StartPlayButton = styled.div`
  width: ${props => 25}vh;
  height: inherit;
  color: ${props => props.color || '#c61818'};
  background-color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  &:after {
    content: '${props => props.text}';
  }
  opacity: ${props => (props.isStarted ? 0.2 : 1)};
`

// const EndPlayButton = styled.div`
//   width: ${props => 25}vh;
//   height: inherit;
//   color: #ffffff;
//   background-color: ${props => props.backgroundColor || '#c61818'};
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   &:after {
//     content: '${props => props.text}';
//   }
//   position: relative;
//   opacity: ${props => (props.locked ? 0.2 : 1)};
// `

const Prompt = styled.span`
  visibility: hidden;
  width: auto;
  min-width: ${props => 16}vh;
  background-color: #17c5ff;
  text-align: center;
  border-radius: ${props => 0.5}vh;
  padding: ${props => 0.5}vh ${props => 0.5}vh;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  right: 0;
  margin-left: ${props => -8}vh;
  opacity: 0;
  transition: opacity 0.3s;
  font-family: pamainregular;
  font-size: ${props => 2}vh;
  color: #000000;

  &:after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: ${props => -0.8}vh;
    border-width: ${props => 0.8}vh;
    border-style: solid;
    border-color: #17c5ff transparent transparent transparent;
  }
`

const ResultButton = styled.div`
  width: ${props => 10}vh;
  height: inherit;
  color: #18c5ff;
  background-color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${props => (props.locked ? 'default' : 'pointer')};
  &:before {
    content: 'PUSH';
    margin-left: ${props => 2}vh;
  }
  &:after {
    width: ${props => h}vh;
    height: ${props => h}vh;
    content: '';
    background-image: url(${ArrowPushIcon});
    background-repeat: no-repeat;
    background-size: 50%;
    background-position: center;
  }

  -webkit-filter: ${props => (props.locked ? 'grayscale(1)' : 'grayscale(0)')};
  opacity: ${props => (props.locked ? 0.2 : 1)};
`

const TimerGroup = styled.div`
  height: auto;
  display: flex;
  flex-direction: row;
`

const TimeLeft = styled.div`
  width: ${props => 25}vh;
  height: inherit;
  display: flex;
  flex-direction: row;
  justify-content: center;
  opacity: 0.2;
`

const TimeLeftLabel = styled.div`
  height: inherit;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: white;
`

const TimeLeftTimer = styled.div`
  height: inherit;
  display: flex;
  align-items: center;
  color: white;
  padding: ${props => 1}vh;
`

const Bold = styled.span`
  font-family: pamainregular;
`

const AdLeft = styled.div`
  width: ${props => 25}vh;
  height: inherit;
  display: flex;
  flex-direction: row;
  justify-content: center;
  opacity: 0.1;
`

const DDSponsorWrapper = styled.div`
  width: 10.4%;
  position: relative;
`

const InfinityIconCont = styled.img`
  position: absolute;
  width: 25px;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 4px;
  z-index: 6;
`



// WEBPACK FOOTER //
// src/Components/CommandHost/PlayItemLoad.js